export default __webpack_public_path__ + "static/media/Pedestal Icons_Fin.0a603299.svg";